/* eslint-disable no-undef */
import React from "react";
import { connect } from "react-redux";
import Layout from "../../Components/Layout";
import SettingsLayout from "./SettingsLayout";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import Api from "../../Server/Api";
import InfoActionPage from "../../Components/InfoActionPage";
import { FormContent } from "../../Components/FormContent";
import { useParams } from "react-router-dom";
import { structure } from "./MedicalProfile2ndOpinion";

const api = new Api();


const MedicalProfile2ndOpinionAdmin = (props) => {
	const defaultMsg = {
		title: "Medical Record Submitted",
		message: `Thank you for submitting your medical record form for easy accessment, one of our doctors will contact you shortly. `,
		image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg").default,
		action: {
			text: "Contact Us",
			action: () => {
				window.open("https://24telemed.org/contact")
			}
		}
	}

	const { identifier } = useParams();
	const [DATA, setDATA] = React.useState({});
	const [view, setView] = React.useState(0);
	const [message, setMessage] = React.useState(defaultMsg);
	const [page, setPage] = React.useState(0);
	const [loading, setLoading] = React.useState(true);



	const updateProfile = (d) => {
		setDATA({ ...DATA, ...d });
	};

	const init = async () => {
		setLoading(true);
		const res = await api.get({ endpoint: `/second-opinion/${identifier}/` });
		if(res?.id > 0){
			if(res?.state === "xxxCOMPLETED") {
				setMessage({
					title: "Record Already Submitted",
					message: `Your medical profile is already submitted. We will get back to you short! If you want to contact us now, you can click the button below.`,
					image: require("../../assets/images/undraw_order_confirmed_re_g0if.svg").default,
					action: {
						text: "Contact Us",
						action: () => {
							window.open("https://24telemed.org/contact")
						}
					}
				});
				setView(1);
			}else{
				setDATA(res?.data)
			}
		}
		setLoading(false);
	}

	React.useEffect(() => { init() }, []);

	const pageValidator = (p) =>{
		const fields = structure[p].fields;
		let check = true;
		try {
			fields.forEach((e) => { if(e.required && !DATA[e.name]) check = false; })
		} catch (error) {
		}
		return check;
	}

	const formValidator = () => {
		let check = true;
		for (let i = 0; i < structure.length; i++) {
			if(!pageValidator(i)){
				check = false;
				break;
			}
		}
		return check;
	}
	if(loading){
		return (
			<div id="huro-app" className="app-wrapper">
				<div className="app-overlay" />
				<div id={"pageloader"} className={`pageloader is-active`} />
				<div id={"infraloader"} className={`infraloader is-active`} />
			</div>
		)
	}

	return (
		<Layout layout={2} mustAuth={false} sidePanel={true} title={"Medical Profile"}>
			<style>
				{`
					.main-sidebar.is-bordered {
						display: none !important;
					}

					.form-layout {
						padding-top: 3rem;
						padding-bottom: 3rem;
					}

					.h-avatar.is-xl {
						max-width: 200px !important;
						min-width: 100px !important;

					}
					.h-avatar.is-xl .avatar {
						width: auto !important;
						min-width: auto !important;
						max-width: 200px !important;
						border-radius: 0 !important;
						height: auto !important;
						margin: auto !important
					}
					.mobile-navbar.no-shadow, .navbar.mobile-navbar.is-hidden-desktop.is-hidden-tablet{
						display: none !important; 
					}
					#huro-app {
						min-height: 100vh !important;
					}

					.main-sidebar.is-bordered {
						display: none;
					}
	
					.view-wrapper {
						width: 100%;
						margin: 0;
					}
	
					.huro-hamburger.nav-trigger.push-resize {
						display: none;
					}
	
					.form-header.stuck-header.is-stuck {
						margin-left: 0;
						width: 100%;
					}
	
					.form-header.stuck-header.is-stuck .right {
						display: none;
					}
	
					.form-header-inner .right {
						display: none;
					}
	
					.message {
						display: none;
					}
	
					.saas-billing-wrapper .plans-wrapper .left .plans .plan input:checked + .plan-inner {
						border-color: #37514b;
						-webkit-box-shadow: -1px 3px 10px 0 rgba(0,0,0,.06);
						box-shadow: -1px 3px 10px 0 rgba(0,0,0,.06);
					}
				`}
			</style>
			<div className="hub-header has-text-centered p-5">
				<div className="h-avatar is-xl mb-3 mt-5">
					<img className="avatar mb-3" 
						src={require("../../assets/images/logo.png").default}
						data-demo-src={require("../../assets/images/logo.png").default}
						alt={"Logo"}
						 />
				</div>
				{/* <h3 className="title is-4 is-narrow">Patient Medical Record</h3> */}
				<p className="light-text">
				Please put a check mark by any symptoms that you have had recently.<br/>Please check “none” if you have not noticed any of the symptoms listed in that category.</p>
				</div>
			{view === 1 ? (
				<InfoActionPage {...message} />
			): (
				<SettingsLayout
					title={"Medical History Form"}
					data={DATA}
					comms={{}}
					endPoint={`/second-opinion/${identifier}/submit/`}
					btnText={"Submit Form"}
					hideCancel={true}
					successCallback={() => setView(1)}
					page={page}
					pageCount={structure.length}
					formWizard={false}
					formValidator={formValidator}
					formWizardNext={() => {
						if(pageValidator(page)){
							setPage(page+1)
						}else{
							notyf.open({
								type: "error",
								message: "Please fill all required fields to continue."
							});
						}
					}}
					formWizardBack={() => setPage(page-1)}
				>

					<div className="form-body p-5" style={{ paddingTop: "0px !important" }}>
						<div className="form-fieldset">
							<div className="columns is-multiline">
								<FormContent
									{...props}
									structure={structure}
									updateProfile={updateProfile}
									PROFILE={DATA}
									formWizard={false}
									page={page}
									readOnly={true}
								/>
							</div>
						</div>
					</div>
				</SettingsLayout>

			)}

		</Layout>
	);
};

const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		closePanel: (e) => dispatch(closePanel(e)),
		openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicalProfile2ndOpinionAdmin);
